<template>
    <div>
      <mcheader></mcheader>
      <div class="shop-banner-area text-center">
        <div class="about-banner-text">
          <div class="banner-title">
            <h2 >Product</h2>
          </div>
          <div class="breadcrumbs">
            <ul>
              <li class="home"><a href="index.html">Home</a><span> > </span></li>
              <li>Shop</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- banner end -->
      <!-- shop start -->
      <div class="shop-area-start">
        <div class="container">
          <div class="clearfix"></div>
          <div class="tab-content">
            <div id="grid" class="tab-pane active" role="tabpanel">
              <div class="row">
                <div class="col-xs-12 col-width" v-for="(item,index) in shoplist" :key="index">
                  <div class="shop-single-products">
                    <div class="single-product">
                      <div class="single-product-item">
                        <div class="single-product-img clearfix hover-effect">
                          <a  style="cursor:pointer;" @click="godetail(item)">
                            <img class="primary-image" :src="item.img_url" alt="" style="height: 400px;">
                          </a>
                        </div>
                        <div class="single-product-info clearfix">
                          <div class="pro-rating">
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                          </div>
                          <div class="pro-price">
                            <span class="new-price">${{item.price}}</span>
                            <span class="old-price">${{item.orig_price}}</span>
                          </div>
                          <h3><a href="">{{item.name}}</a></h3>
                        </div>
                        <div class="wish-icon-hover text-center">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <mcfoot></mcfoot>
    </div>
</template>

<script>
import mcheader from '@/components/Mcheader'
import mcfoot from '@/components/Mcfoot'
import https from './js/https.js'
export default {
  name: 'shoplist',
  components:
    {
      mcheader,
      mcfoot
    },
  data () {
    return {
      shoplist: []
    }
  },
  methods: {
    getshoplist () {
      console.log(this.$route)
      https.fetchGet('mocalilie/api/products', {
        categoryId: this.$route.query.id
      }).then((res) => {
        console.log(res.data.data)
        this.shoplist = res.data.data
      })
    },
    godetail (i) {
      this.$router.push({
        name: 'detail',
        query: {
          productId: i.id
        }
      })
    }
  },
  created () {
    this.getshoplist()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/shoplist.vue